import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  FormGroupDirective,
  UntypedFormControl,
} from '@angular/forms';

@Component({
  selector: 'app-easy-time-picker',
  templateUrl: './easy-time-picker.component.html',
  styleUrls: ['./easy-time-picker.component.scss'],
})
export class EasyTimePickerComponent {
  @Input() hours: string[] = [];

  @Input() form!: UntypedFormGroup;

  onScroll($event: WheelEvent, property: string) {
    $event.preventDefault();

    if ($event.deltaY < 0) {
      this.up(property);
    } else if ($event.deltaY > 0) {
      this.down(property);
    }
  }

  up(property: string): void {
    if (this.form.enabled) {
      this.form.markAsDirty();
      const value = this.form.value;
      const index = this.hours.indexOf(this.form.value[property]);

      if (index + 1 < this.hours.length) {
        this.form.setValue({ ...value, [property]: this.hours[index + 1] });
      } else {
        this.form.setValue({ ...value, [property]: this.hours[0] });
      }
    }
  }

  down(property: string): void {
    if (this.form.enabled) {
      this.form.markAsDirty();
      const value = this.form.value;
      const index = this.hours.indexOf(this.form.value[property]);

      if (index - 1 >= 0) {
        this.form.setValue({ ...value, [property]: this.hours[index - 1] });
      } else {
        this.form.setValue({
          ...value,
          [property]: this.hours[this.hours.length - 1],
        });
      }
    }
  }

  onSelectionChange(selectedTime: string, property: string) {
    const value = this.form.value;
    this.form.markAsDirty();
    this.form.setValue({ ...value, [property]: selectedTime });
  }
}
